import { render } from "./create_rate.vue?vue&type=template&id=61d49ddf"
import script from "./create_rate.vue?vue&type=script&lang=js"
export * from "./create_rate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__